import { Flex } from "../Flex";
import { SubjectTypeIcon } from "../SubjectTypeIcon";
import theme from "../../theme";

export const SubjectNameCell = ({
  type,
  companyName,
  firstName,
  lastName,
}: {
  type?: string;
  companyName?: string;
  firstName?: string;
  lastName?: string;
}) => {
  const isEntity = type === "entity" || (type !== "individual" && !!companyName);

  const name =
    type === "entity"
      ? `${companyName}`
      : type === "individual"
      ? `${firstName} ${lastName}`
      : companyName
      ? `${companyName}`
      : `${firstName} ${lastName}`;

  return (
    <Flex alignItems="center" gap="8">
      <SubjectTypeIcon isEntity={isEntity} />
      <span
        style={{
          fontWeight: 600,
          fontSize: "15px",
          color: theme.colors.darkBlue,
        }}
      >
        {name}
      </span>
    </Flex>
  );
};
